import React from 'react';
import classes from './Cart.module.css';
import {
  deleteCartByIndex,
  ICartProduct,
  selectCart,
  handleQuantityCart,
} from '../../store/slices/cart';
import deleteIcon from '../../assets/icons/delete-icon.svg';
import orderProductIcon from '../../assets/icons/order-product.png';
import editBoard from '../../assets/icons/pen2.svg';
import { useAppDispatch, useAppSelector } from '../../store/store';
import moment from 'moment';

import plusIcon from '../../assets/icons/plusIcon.svg';
import minusIcon from '../../assets/icons/minusIcon.svg';
import { toast } from 'react-toastify';
import POSITION = toast.POSITION;
import { CustomCalendarModal } from './Modals/CustomCalendarModal';
import { useTranslation } from '../../hooks/useTranslations';
type Props = {};

const Cart: React.FC<Props> = ({}) => {
  const [isEditingCart, setIsEditingCart] = React.useState<ICartProduct>();
  const [index, setIndex] = React.useState<number>(0);
  const carts = useAppSelector<ICartProduct[]>(selectCart);
  const dispatch = useAppDispatch();
  const { translations } = useTranslation();
  const lang = localStorage.getItem('lang') || 'en';
  const quantityHandler = (productId: number, operation: string) => {
    dispatch(handleQuantityCart({ productId: productId, operation: operation }));
  };
  const editHandler = (product: ICartProduct, index: number) => {
    setIsEditingCart(product);
    setIndex(index);
  };
  return (
    <div className={classes.container}>
      <div className={classes.cartHeader}>
        <div className={classes.rowItemLarge}>{translations('product')}</div>
        <div className={classes.rowItemLarge}>{translations('appointment.date')}</div>
        <div className={classes.rowItem}>{translations('quantity')}</div>
        <div className={classes.rowItem}>{translations('total')}</div>
        <div className={classes.rowItem} />
      </div>
      <div className={classes.cartBody}>
        {carts.map((product, index) => (
          <div className={classes.cartRow} key={index}>
            <div className={classes.rowItemLarge}>
              <img
                alt={'product icon'}
                src={
                  product.product.images && product.product.images.length > 0
                    ? product.product.images[0].url
                    : orderProductIcon
                }
                className={classes.productIcon}
              />
              <p>{product.product.name.length >= 1 ? product.product.name[0].text : ''}</p>
            </div>
            <div className={classes.rowItemLarge}>
              {product.appointmentStart ? (
                <div className={classes.appointment}>
                  <div className={classes.appointmentDay}>
                    {moment(product.appointmentStart).locale(lang).format('dddd')}
                  </div>
                  <div className={classes.appointmentDate}>
                    {moment(product.appointmentStart).format('DD.MM.yyyy - HH:mm')}
                  </div>
                </div>
              ) : (
                <div className={classes.appointment}>
                  <div className={classes.appointmentDay}>{translations('no_appointment')}</div>
                </div>
              )}
            </div>
            <div className={classes.rowItem}>
              {product.product.product_group === 'H' && (
                <div key={index} className={classes.addToCartContainer}>
                  <div className={classes.quantityContainer}>
                    <img
                      src={minusIcon}
                      onClick={() => quantityHandler(product.product.product_id, 'decrement')}
                      alt="minus"
                      className={classes.quantity}
                    />
                    <div className={classes.value}>{product.quantity}</div>
                    <img
                      src={plusIcon}
                      onClick={() => quantityHandler(product.product.product_id, 'increment')}
                      alt="plus"
                      className={classes.quantity}
                    />
                  </div>
                </div>
              )}
            </div>
            <div className={classes.rowItem}>
              {product.product.price ? `€ ${(product.product.price / 100).toFixed(2)}` : '€ 0.00'}
            </div>
            <div className={classes.rowItem} style={{ display: 'flex' }}>
              <div className={classes.editIcon}>
                {product.product.product_group !== 'H' && (
                  <img
                    className={classes.appointmentEdit}
                    src={editBoard}
                    alt={'edit'}
                    onClick={() => {
                      editHandler(product, index);
                    }}
                  />
                )}
              </div>
              <div className={classes.deleteIconContainer}>
                <img
                  alt={'delete-icon'}
                  src={deleteIcon}
                  className={classes.deleteIcon}
                  onClick={() => {
                    dispatch(deleteCartByIndex({ index }));
                    toast.success(translations('product.deleted'), {
                      position: POSITION.BOTTOM_RIGHT,
                    });
                  }}
                />
              </div>
            </div>
          </div>
        ))}
      </div>

      {isEditingCart && (
        <CustomCalendarModal
          product={isEditingCart.product}
          isOpen={!!isEditingCart}
          onClose={() => setIsEditingCart(undefined)}
          editingCart={isEditingCart}
          index={index}
        />
      )}
    </div>
  );
};

export { Cart };
